const blue = {
  100: '#0486FE',
  90: '#369EFE',
  30: '#B4DBFF',
  20: '#CDE7FF',
  15: '#ECF6FF',
  10: '#E6F3FF',
};
export default blue;
